<template>
  <div class="content-body" id="tender">
        <!-- --------------start modal New tender----------- -->
        <div class="modal fade animated slideInDown text-left" id="modaNewTender" tabindex="-1" v-if="newTenderModal">
            <div class="modal-dialog" role="document" style="min-width: 50vw; max-width: 98vw">
            <div class="modal-content">
                <div class="card-header" style="border-radius: 0.27rem">
                    <h4 class="card-title">Новий тендер</h4>
                    <div class="heading-elements">
                        <button type="button" id="closeBtn" ref="closeModalEq" class="btn btn-warning" data-dismiss="modal" @click="newTenderModal = false">
                            <!--<span aria-hidden="true">&times;</span>-->
                            <i class="icon-cross" style="color: white"></i>
                        </button>
                    </div>
                </div>

                <div class="modal-body">
                    <div class="container-fluid">
                        <div class="row">                            
                            <div class="col-md-6">
                                <div class="form-group" style="position: relative">                                   
                                    <div class="form-group">
											<label for="projectinput5">{{$t('tender.label.direction')}}</label>
											<select id="projectinput5" name="interested" class="form-control" v-model="newTender.type">
                                                <option selected></option>
                                                <option value="1">{{$t('tender.trType.1')}}</option>
                                                <option value="2">{{$t('tender.trType.2')}}</option>
                                                <option value="3">{{$t('tender.trType.3')}}</option>
                                                <option value="4">{{$t('tender.trType.4')}}</option>
											</select>
										</div>                                                                                          
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group" style="position: relative">                                   
                                    <div class="form-group">
											<label for="projectinput5">{{$t('tender.label.trType')}}</label>
											<select id="projectinput5" name="interested" class="form-control" v-model="newTender.type">
                                                <option selected></option>
                                                <option value="1">{{$t('tender.direction.1')}}</option>
                                                <option value="2">{{$t('tender.direction.2')}}</option>                                           
											</select>
										</div>                                                                                          
                                </div>
                            </div>

                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group" style="position: relative">                                   
                                        <label>Бажана вартість</label>
                                        <input class="form-control border-primary" type="number"  v-model="newTender.price" >                                   
                                                                                                                           
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group" style="position: relative">                                   
                                    <div class="form-group">
											<label for="projectinput5">Валюта</label>
											<select id="projectinput5" name="interested" class="form-control" v-model="newTender.сurrency">
											<option selected></option>
                                            <option value="1">UAN</option>
                                            <option value="2">USD</option>
                                            <option value="3">EUR</option>
											</select>
										</div>                                                                                          
                                </div>
                            </div>

                        </div>
                         <div class="row" v-if="newTender.children.length != 0">
                            <div class="col-md-12">
                                <div class="mobileTbl table-responsive">
                                    <table class="table table-hover mb-0" cellspacing="0">
                                        <thead>
                                            <tr>                                                
                                                <th style="vertical-align: middle;">{{ $t('tender.table.download') }}</th>                                                
                                                <th style="vertical-align: middle;">{{ $t('tender.table.delivery') }}</th>                                                
                                                <th style="vertical-align: middle;">{{ $t('tender.table.customsCrossing') }}</th>
                                                <th style="vertical-align: middle;">{{ $t('tender.table.productWeight') }}</th>
                                                <th style="vertical-align: middle;">{{ $t('tender.table.typeOfCar') }}</th>
                                                <th style="vertical-align: middle;">{{ $t('tender.table.downloadType') }}</th> 
                                                                                                                          
                                            </tr>
                                        </thead>                                                       
                                        <tbody>                              
                                            <tr class="marginTR" v-for="(item,index) in newTender.children" :key="index"> 
                                                <td :data-title="$t('tender.table.download')">
                                                    <span><b>{{item.downloadDate}}</b></span><br />
                                                    <span>{{item.downloadAdress}}</span>                                                    
                                                </td>
                                                <td :data-title="$t('tender.table.delivery')">
                                                    <span><b>{{item.deliveryDate}}</b></span> <br />
                                                    <span>{{item.deliveryAdress}}</span>                                                    
                                                </td>
                                                <td  :data-title="$t('tender.table.customsCrossing')">{{item.customsCrossing}}</td>
                                                <td  :data-title="$t('tender.table.productWeight')">{{item.productWeight}}</td>
                                                <td  :data-title="$t('tender.table.typeOfCar')">{{item.typeOfCar}}</td>
                                                <td  :data-title="$t('tender.table.downloadType')">{{item.downloadType}}</td>
                                                                                                
                                            </tr>                                                                                                           
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="mobileTbl table-responsive">
                                <table class="table table-hover mb-0" cellspacing="0">
                                    <thead>
                                        <tr>
                                            <th style="vertical-align: middle;">{{ $t('tender.table.downloadAdress') }}</th>
                                            <th style="vertical-align: middle;">{{$t('tender.table.downloadDate')}}</th>
                                            <th style="vertical-align: middle;">{{$t('tender.table.deliveryAdress')}}</th>
                                            <th style="vertical-align: middle;">{{$t('tender.table.deliveryDate')}}</th>
                                            <th style="vertical-align: middle;">{{$t('tender.table.productWeight')}}</th>
                                            <th style="vertical-align: middle;">{{$t('tender.table.typeOfCar')}}</th>
                                            <th style="vertical-align: middle;">{{$t('tender.table.downloadType')}}</th>
                                            <th style="vertical-align: middle;"></th> 
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td :data-title="$t('tender.table.downloadAdress')">
                                                <div class="form-group mb-0">
                                                    <div class="position-relative">
                                                        <textarea rows="3" id="downloadAdress" class="form-control" name="downloadAdress" v-model="newTenderChildren.downloadAdress" ></textarea>
                                                    </div>
                                                </div>
                                            </td>
                                            <td :data-title="$t('tender.table.downloadDate')">
                                                <div class="form-group mb-0">
                                                    <div class="position-relative">
                                                        <input type="date" id="downloadDate" class="form-control" name="downloadDate" v-model="newTenderChildren.downloadDate" >
                                                    </div>
                                                </div>
                                            </td>
                                            <td :data-title="$t('tender.table.deliveryAdress')">
                                                <div class="form-group mb-0">
                                                    <div class="position-relative">
                                                         <textarea rows="3" id="deliveryAdress" class="form-control" name="deliveryAdress" v-model="newTenderChildren.deliveryAdress" ></textarea>
                                                    </div>
                                                </div>
                                            </td>
                                            <td :data-title="$t('tender.table.deliveryDate')">
                                                <div class="form-group mb-0">
                                                    <div class="position-relative">
                                                        <input type="date" id="deliveryDate" class="form-control" name="deliveryDate" v-model="newTenderChildren.deliveryDate" >
                                                    </div>
                                                </div>
                                            </td>
                                            <td :data-title="$t('tender.table.productWeight')">
                                                <div class="form-group mb-0">
                                                    <div class="position-relative">
                                                        <input type="number" id="productWeight" class="form-control" name="productWeight" v-model="newTenderChildren.productWeight" >
                                                    </div>
                                                </div>
                                            </td>
                                            <td :data-title="$t('tender.table.typeOfCar')">
                                                <div class="form-group mb-0">
                                                    <div class="position-relative">
                                                        <input type="text" id="typeOfCar" class="form-control" name="typeOfCar" v-model="newTenderChildren.typeOfCar" >
                                                    </div>
                                                </div>
                                            </td>
                                            <td :data-title="$t('tender.table.downloadType')">
                                                <div class="form-group mb-0">
                                                    <div class="position-relative">
                                                        <input type="text" id="downloadType" class="form-control" name="downloadType" v-model="newTenderChildren.downloadType" >
                                                    </div>
                                                </div>
                                            </td> 
                                            <td class="text-truncate">
                                                    <div class="row" style="float: right; margin-right: 5px">
                                                    <div class="btn-group">
                                                        <button type="button" class="btn btn-warning" @click="addLineTuTables()">
                                                            <i class="icon-plus2"></i>
                                                        </button>                                                       
                                                    </div>
                                                    </div>
                                                </td>               
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>
                    
                    
                    <div class="row">
                           <div class="col-md-12 d-flex justify-content-center">                                
                                <div class="form-group" style="position: relative">                                                            
                                    <fieldset class="form-group position-relative">
                                        <button class="btn btn-primary dropdown-item" type="button" data-toggle="modal" data-target="#modalEq" @click.prevent="addNewTender()">
                                            Зберегти
                                        </button>   
                                    </fieldset>                                
                                </div>
                            </div>
                        </div>
                </div>
                <!-- <div class="modal-footer">
                    <h2 for="">Ставка не може перевищувати 1300 грн.</h2>
                </div> -->
            </div>
            </div>
        </div>
    <!-- -------------- and modal----------- -->

       <!-- --------------start modal acsept----------- -->
        <div class="modal fade animated slideInDown text-left" id="modalEq" tabindex="-1" v-if="$store.state.modalBody">
            <div class="modal-dialog" role="document" >
            <div class="modal-content">
                <div class="card-header" style="border-radius: 0.27rem">
                    <h4 class="card-title">{{$t('tender.label.confirm')}}</h4>
                    <div class="heading-elements">
                        <button type="button" id="closeBtn" ref="closeModalEq" class="btn btn-warning" data-dismiss="modal" @click="$store.state.modalBody = false, user_rate = null">
                            <!--<span aria-hidden="true">&times;</span>-->
                            <i class="icon-cross" style="color: white"></i>
                        </button>
                    </div>
                </div>

                <div class="modal-body">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-8 d-flex justify-content-start">
                                <div class="form-group" style="position: relative" >                                   
                                        <label>{{$t('tender.label.youCost')}}</label>
                                        <div class="input-group">
                                        <input class="form-control border-primary" type="number"  v-model="user_rate" aria-describedby="user_rate" >  
                                        <div class="input-group-append">
                                            <span class="input-group-text" id="user_rate">
                                                {{selecteadTender.currency}}
                                            </span>
                                        </div>                                 
                                        </div>                                                                                     
                                </div>
                            </div>
                            <div class="col-md-4 d-flex justify-content-center pr-1" style="margin-top:13px;">                                
                                <div class="form-group" style="position: relative">                                                            
                                    <fieldset class="form-group position-relative">
                                        <button class="btn btn-icon btn-outline-success" :disabled="userRateError" type="button" data-toggle="modal"  data-target="#modalEq" @click.prevent="submitRate">
                                            {{$t('tender.button.confirm')}}
                                            <font-awesome-icon icon="money-check-alt" class="cursor success"  />
                                        </button>   
                                    </fieldset>                                
                                </div>
                            </div>
                        </div>   
                    </div>
                 </div>
                    <div class="editional-info d-flex ">
                        <div>
                            <h6>Додаткові вимоги</h6>
                            <b>{{$t('tender.table.coments')}}:</b><span>{{selecteadTender.comment}}</span>                             
                        </div>
                    </div>
                  <div class="modal-footer">
                    <label class="acsept-desk"> {{$t('tender.label.exceptText')}} <b>{{minRate}}{{selecteadTender.currency}}</b></label><br>
                    <label class="acsept-desk"> {{$t('tender.label.costStep')}} <b>{{selecteadTender.step}}{{selecteadTender.currency}}</b></label>
                </div>
             
            </div>
             
            </div>
        </div>
    <!-- -------------- and modal----------- -->
 

    <!-- Modal select-winner -->
        <modal name="select-winner" :adaptive="true">
         <div class="card">
             <div class="card-header" style="border-radius: 0.27rem">
                <h4 class="card-title">{{$t('tender.button.confirmWinner')}}</h4>
                <div class="heading-elements">
                    <button type="button" id="closeBtn" ref="closeModalEq" class="btn btn-warning" data-dismiss="modal" @click="$modal.hide('select-winner')">
                        <!--<span aria-hidden="true">&times;</span>-->
                        <i class="icon-cross" style="color: white"></i>
                    </button>
                </div>
            </div>
             <div class="card-body">
                  <div class="form-group mx-2">
                    <label for="commentForWinner">{{$t('tasks.table.comment')}}*</label>
                        <div class="position-relative">
                            <textarea rows="3" class="form-control" name="commentForWinner" v-model="commentForWinner" ></textarea>
                    </div>
                </div>
                <div class="d-flex justify-content-end mt-2">               
                <div class="form-group">                     
                    <div class="btn-group">
                        <button type="button"  class="btn btn-outline-success btn-min-width btn-glow mr-1 mb-1" @click="setWinTender()"><i class="icon-checkmark"></i> {{$t('label.confirm')}}</button>
                    </div>                    
                </div>                
                </div>
             </div>         
        </div>
         <!--  // and card -->           
    </modal>
    <!-- And modal select-winner -->
     <!-- Modal close-tender -->
        <modal name="close-tender" :adaptive="true" :height="modalNimHeaght">
         <div class="card">
            <div class="card-header" style="border-radius: 0.27rem">
                <h5 class="card-title">{{$t('tender.button.confirmWinner')}}</h5>                
                <div class="heading-elements">
                    <button type="button" id="closeBtn" ref="closeModalEq" class="btn btn-warning" data-dismiss="modal" @click="$modal.hide('close-tender')">
                        <!--<span aria-hidden="true">&times;</span>-->
                        <i class="icon-cross" style="color: white"></i>
                    </button>
                </div>                
            </div>
            <div class="card-body">
                <div class="row">
                    <h5>{{$t('tender.label.confirmCloseTender')}}</h5> 
                </div>
                
            </div>
            <div class="form-actions">
                <div class="d-flex justify-content-end mt-2">               
                    <div class="form-group">                     
                        <div class="btn-group">
                            <button type="button"  class="btn btn-outline-success btn-min-width btn-glow mr-1 mb-1" @click="closeTender()"><i class="icon-checkmark"></i> {{$t('label.confirm')}}</button>
                        </div>                    
                    </div>                
                </div>
            </div>         
        </div>
         <!--  // and card -->           
    </modal>
    <!-- And modal close-tender -->
    <!-- Modal cansel tender -->
        <vue-modal :on-close="closeModal('cansel-tender')"  name="cansel-tender" :adaptive="true" :scrollable="true"  >
                <h2 slot="header">{{$t('tender.button.canselTender')}}: <span v-if="descTablesData" class="badge badge-secondary">{{descTablesData.number}}</span></h2>
            <!-- <h3 slot="header" style="text-align:center"></h3> -->
            <div class="d-flex justify-content-end">
                <div class="form-group">
                    <div class="btn-group">
                        <button type="button"  class="btn btn-outline-success btn-min-width btn-glow mr-1 mb-1" @click="canselTender(descTablesData.guidDoc)"><i class="icon-checkmark"></i> {{$t('label.confirm')}}</button>
                        <button type="button"  class="btn btn-outline-danger btn-min-width btn-glow mr-1 mb-1" @click="closeModal('cansel-tender')"><i class="icon-cross"></i> {{$t('label.cansel')}}</button>
                    </div>
                    
                </div>
            </div>   
        </vue-modal>
    <!-- And modal cansel tender -->
    <!-- Modal cancel-user-part -->
     <modal name="cancel-user-part" :adaptive="true">
         <div class="card">
             <div class="card-header" style="border-radius: 0.27rem">
                <h4 class="card-title">{{$t('label.canсel-part')}}</h4>
                <div class="heading-elements">
                    <button type="button" id="closeBtn" ref="closeModalEq" class="btn btn-warning" data-dismiss="modal" @click="$modal.hide('cancel-user-part')">
                        <!--<span aria-hidden="true">&times;</span>-->
                        <i class="icon-cross" style="color: white"></i>
                    </button>
                </div>
            </div>
             <div class="card-body">
                  <div class="form-group mx-2">
                    <label for="reasonForCancellations">{{$t('tender.table.coments')}}*</label>
                        <div class="position-relative">
                            <textarea rows="3" class="form-control" name="reasonForCancellation" v-model="reasonForCancellation" ></textarea>
                    </div>
                </div>
                <div class="d-flex justify-content-end mt-2">               
                <div class="form-group">                     
                    <div class="btn-group">
                        <button type="button" :disabled="!reasonForCancellation"  class="btn btn-outline-success btn-min-width btn-glow mr-1 mb-1" @click="canselUserPart()"><i class="icon-checkmark"></i> {{$t('label.confirm')}}</button>
                    </div>                    
                </div>                
                </div>
             </div>         
        </div>
         <!--  // and card -->           
    </modal>
     <!-- Modal add user comment -->
     <modal name="user-comment" :adaptive="true" :height="modalNimHeaght">
         <div class="card">
             <div class="card-header" style="border-radius: 0.27rem">
                <h4 class="card-title">{{$t('tender.label.offerABid')}}</h4>
                <div class="heading-elements">
                    <button type="button" id="closeBtn" ref="closeModalEq" class="btn btn-warning" data-dismiss="modal" @click="$modal.hide('user-comment')">
                        <!--<span aria-hidden="true">&times;</span>-->
                        <i class="icon-cross" style="color: white"></i>
                    </button>
                </div>
            </div>
             <div class="card-body">
                  <div class="form-group mx-2">
                    <label for="comment">{{$t('tender.table.coments')}}*</label>
                        <div class="position-relative">
                            <textarea rows="3" class="form-control" name="comment" v-model="userComment" ></textarea>
                    </div>
                </div>
                <div class="d-flex justify-content-end mt-2">               
                <div class="form-group">                     
                    <div class="btn-group">
                        <button type="button"  class="btn btn-outline-success btn-min-width btn-glow mr-1 mb-1" @click="addUserComment()"><i class="icon-checkmark"></i> {{$t('label.send')}}</button>
                    </div>                    
                </div>                
                </div>
             </div>         
        </div>
         <!--  // and card -->           
    </modal>

     <!-- Modal edit tender -->
     <modal name="edit-tender" :adaptive="true" :minHeight="320">
         <div class="card">
             <div class="card-header" style="border-radius: 0.27rem">
                <h4 class="card-title">{{$t('tender.label.editTender')}}</h4>
                <div class="heading-elements">
                    <button type="button" id="closeBtn" ref="closeModalEq" class="btn btn-warning" data-dismiss="modal" @click="$modal.hide('edit-tender')">
                        <!--<span aria-hidden="true">&times;</span>-->
                        <i class="icon-cross" style="color: white"></i>
                    </button>
                </div>
            </div>
             <div class="card-body pb-2">
                <div class="row">
                    <div class="col-md-7">
                        <div class="form-group">
                            <label for="number" class="">{{ $t('tender.table.number') }}</label>
                            <input type="text" id="number" class="form-control" :placeholder="selecteadTender.number" name="number" disabled>
                        </div>
                    </div>
                    <div class="col-md-5">
                        <div class="form-group">
                            <label for="closeDay" class="">{{ $t('tender.table.closeDay') }}</label>
                            <!-- <input type="text" id="closeDay" class="form-control" :placeholder="selecteadTender.closeDate" name="closeDay" disabled> -->
                            <date-picker v-model="selecteadTender.closeDate" :formatter="momentFormat" type="datetime" value-type="DD.MM.YYYY HH:mm:ss" format="DD.MM.YYYY HH:mm:ss" title-format="DD.MM.YYYY HH:mm:ss"></date-picker>
                        </div>
                    </div>
                </div>
                 <div class="row">
                    <div class="col-md-12">
                        <!-- <div class="form-group">
                            <label for="closeDay" class="">{{ $t('tender.table.closeDay') }}</label>                            
                            <date-picker v-model="selecteadTender.closeDate" :formatter="momentFormat" type="datetime" value-type="DD.MM.YYYY HH:mm:ss" format="DD.MM.YYYY HH:mm:ss" title-format="DD.MM.YYYY HH:mm:ss"></date-picker>
                        </div> -->
                        <div class="form-group">
                            <label for="price" class="">{{ $t('tender.table.price') }}</label>
                            <input type="number" id="price" class="form-control" v-model="selecteadTender.cost" name="closeDay" >
                        </div>
                    </div>
                    <!-- <div class="col-md-6">
                            <div class="d-flex justify-content-end mt-2">                     
                                <div class="btn-group">
                                   
                                    <button type="button"  class="btn btn-outline-success btn-min-width btn-glow mr-1 mb-1" @click="updateTende()"><i class="icon-checkmark"></i> {{$t('label.confirm')}}</button>
                                </div>                    
                            </div>                        
                    </div> -->
                </div>
                <div class="d-flex justify-content-end mt-2 ">               
                <div class="form-group">                     
                    <div class="btn-group">
                        <button type="button"  class="btn btn-outline-success btn-min-width btn-glow mb-1" @click="updateTende()"><i class="icon-checkmark"></i> {{$t('label.confirm')}}</button>
                    </div>                    
                </div>                
                </div>
             </div>         
        </div>
         <!--  // and card -->           
    </modal>


       <!-- <vue-modal  name="cancel-user-part" :outerClose="false"  >
        <h2 slot="header">{{$t('label.canсel-part')}}? </h2>            
            
            <div class="d-flex justify-content-end mt-2">               
                <div class="form-group">                     
                    <div class="btn-group">
                        <button type="button" :disabled="!reasonForCancellation"  class="btn btn-outline-success btn-min-width btn-glow mr-1 mb-1" @click="canselUserPart()"><i class="icon-checkmark"></i> {{$t('label.confirm')}}</button>
                        <button type="button"  class="btn btn-outline-danger btn-min-width btn-glow mr-1 mb-1" @click="closeModal('cancel-user-part')"><i class="icon-cross"></i> {{$t('label.cansel')}}</button>
                    </div>                    
                </div>                
            </div>           
        </vue-modal> -->

    <!-- And modal cancel-user-part -->
    <div class="row match-height">
		  <div class="col-md-12">
                <!--------------------------------- Logist view --------------------------->
                 <div class="card" v-if="userRole == 'admin' || userRole == 'logist'">
                    <div class="card-header">
                        <h3 class="card-title" ref="card-title"><i class="icon-price-tags"></i> {{$t('titles.transport_tender')}}</h3>
                        <div class="heading-elements">
                            <button  data-toggle="tooltip" data-html="true" :title="$t('tender.button.update')" type="button" class="btn btn-sm btn-icon btn-outline-warning ex-button" @click="getAllTender()"><font-awesome-icon icon="sync" class="cursor warning"  /><span class="btn-desc">{{$t('tender.button.update')}}</span></button>                                                     
                            <!-- <button  type="button" class="btn btn-warning"  data-toggle="modal" data-target="#modaNewTender" @click="newTenderModal = true">
                                <i style="color: #FFFFFF" class="icon-plus2"></i>ygtyfghvfghv
                            </button> -->
                            <!-- <span @click="changeView('table')" class="view-svicher"><i style="color: #000" class="icon icon-table"></i></span>
                            <span @click="changeView('card')" class="view-svicher"><i style="color: #000" class="icon icon-file-text"></i></span> -->
                        </div>
                    </div>
                    <div class="card-body">
                        
                        <div class="row p-1" ref="desc"  id="desc" v-if="descTablesData">
                            <div class="d-flex flex-row justify-content-between"  >
                                <div class="p-2">
                                    <button :disabled="winnerSubmited" data-toggle="tooltip" :title="$t('tender.button.canselTender')"   type="button" class="btn btn-danger"   @click="canselTenderModal()">
                                        <i style="color: #FFFFFF" class="icon-bin"></i>
                                    </button>
                                     <button type="button" data-toggle="tooltip" :title="$t('tender.button.confirmWinner')" class="btn btn-primary"   @click="$modal.show('close-tender')">
                                        <i style="color: #FFFFFF" class="icon-close"></i>
                                    </button>
                                     <button type="button" data-toggle="tooltip" :title="$t('tender.label.editTender')"  class="btn btn-warning"   @click="editTenderModal(descTablesData.guidDoc)">
                                       <i style="color: #FFFFFF" class="icon-pencil"></i>
                                    </button>
                                </div>
                                <div class="p-2">
                                    <span class="link " @click="descTablesData = !descTablesData, unsetActive()"><font-awesome-icon class="sicon" icon="window-close" /></span>
                                </div>
                            
                            </div>
                            <div class="rate-des px-2" >
                                 <ul class="list-inline">
                                    <li class="list-inline-item"><b>{{ $t('tender.table.number')}}:</b> <span class="order-desc">{{descTablesData.number}}</span></li>
                                    <li class="list-inline-item"><b>{{ $t('tender.table.date')}}:</b> <span class="order-desc">{{descTablesData.dateDoc}}</span></li>
                                    <li class="list-inline-item"><b>{{ $t('tender.table.price')}}:</b> <span v-if="descTablesData.rate" class="text-center  ">
                                        <span class="tag tag-success">{{descTablesData.rate}}&nbsp;{{descTablesData.currency}}</span></span>
                                    </li>
  
                                </ul>
                                <ul class="list-inline">
                                    <li class="list-inline-item"><b>{{ $t('table.typeTS')}}:</b> <span class="order-desc">{{descTablesData.volume}}</span></li>
                                    <li class="list-inline-item"><b>{{ $t('table.cargo')}}:</b> <span class="order-desc">{{descTablesData.cargo}}</span></li>
                                    <li class="list-inline-item"><b>{{ $t('tender.table.downloadType')}}:</b> <span class="order-desc">{{descTablesData.typeBoot}}</span></li>
                                    <!-- <li class="list-inline-item"><b>{{ $t('tender.table.сonditions')}}:</b> </b> <span class="order-desc">{{descTablesData.сonditions}}</span></li> -->
                                </ul>
                                 <ul class="list-inline">                                    
                                    <li class="list-inline-item"><b>{{ $t('tender.table.сonditions')}}:</b> <span class="order-desc">{{descTablesData.сonditions}}</span></li>
                                </ul>
                            </div>

                            
                            <div class="col-md-12" v-if="descTablesData && descTablesData.listRates && descTablesData.listRates.length > 0">
                                 <div class="main-tables mobileTbl table-responsive" >
                                    <table class="table table-hover mb-0 loading" cellspacing="0" >
                                        <thead>
                                            <tr>     
                                                <th style="vertical-align: middle;">{{ $t('titles.roles.client') }}</th>                                                           
                                                <th style="vertical-align: middle;">{{ $t('tender.table.rate') }}</th>                                           
                                                <th style="vertical-align: middle;">{{ $t('tender.table.nonVAT') }}</th>                                           
                                                <th style="vertical-align: middle;">{{ $t('tender.table.coments') }}</th>                                           
                                                <th style="vertical-align: middle;">{{ $t('tender.table.status') }}</th>                                           
                                                <th style="vertical-align: middle;">{{ $t('tender.table.persone') }}</th>                                           
                                                <th style="vertical-align: middle;">{{ $t('users.table.email') }}</th>                                         
                                                <th style="vertical-align: middle;">{{ $t('users.table.phone') }}</th>                                           
                                                <th style="vertical-align: middle;"></th>                           
                                            </tr>
                                        </thead>                                                       
                                        <tbody>                              
                                            <tr class="marginTR" v-for="(item,index) in descTablesData.listRates" :key="index" > 
                                                <td :data-title="$t('titles.roles.client')"> {{item.client}}  </td>                                                                                    
                                                <td  :data-title="$t('tender.table.rate')">
                                                    <span  class="text-center ">
                                                        <!-- v-if="item.cost"  {{item.cost}}&nbsp;{{item.currency}} -->
                                                        <span v-for="(cl,k) in item.arrayRate" :key="k" >
                                                            <span class="cost" :class="getCostClass(item.arrayRate,k, cl)"> {{cl}}&nbsp;{{item.currency}}
                                                                <img :src="svgBestRate"  class="svgIcon" v-if="isBestCost(cl)"/>
                                                            </span>
                                                        </span>                                                        
                                                    </span>

                                                </td>
                                                <td  :data-title="$t('tender.table.nonVAT')">                                                    
                                                    <span class="cost" v-if="parseInt(item.vat,10) > 0"> {{item.vat}}&nbsp;{{item.currency}}</span>
                                                </td>

                                                <td :data-title="$t('tender.table.coments')"> {{item.comment}}  </td>   
                                                <td :data-title="$t('tender.table.status')" > 
                                                    <!-- <span v-if="item.refusal" class="badge" :class="$t('tender.statuses.6.class')">{{ $t('tender.statuses.6.title') }}</span>   -->
                                                    <span v-if="item.status !=0" class="badge" :class="$t('tender.userTenderStatus.' + item.status + '.class')">{{ $t('tender.userTenderStatus.' + item.status + '.title') }}</span> 
                                                </td>   
                                                <td :data-title="$t('tender.table.persone')"> {{item.persone}}
                                                     <img :src="svgNoTax"  class="svgIcon" v-if="!item.payerVAT"/> 
                                                      
                                                </td>   
                                                <td :data-title="$t('users.table.email')"> {{item.email}}  </td>   
                                                <td :data-title="$t('users.table.phone')"> {{item.mobile}}  </td> 
                                                <td ><button v-if="item.cost >= 0  && item.status == 0 && descTablesData.mainStatus !=3" :disabled="winnerSubmited"  class="btn btn-success btn-block mb-2" type="button" data-toggle="modal" data-target="#select-winner" @click="showModalWinn(item, 'select-winner')">
                                                    {{$t('tender.button.setWinner')}}
                                                </button></td>
                                                
                                            </tr>   
                                        </tbody>
                                    </table>
                              </div>
                        <!-- ____________________and main tables -->
                               
                        </div>


                        </div>
                        <!---------------- start filter block -->
                        <div class="row" id="logist-filter">
                            <div class="col-md-12">
                                <fieldset class="position-relative">
                                    <input type="text" class="form-control form-control input" placeholder="" v-model="filterStr" >
                                    <div class="form-control-position" style="top:13px; right:10px;">
                                        <i class="icon-search4 font-medium-4"></i>
                                    </div>
                                </fieldset>
                            </div>
                        </div>
                        <div class="row" style="padding-left:7px">
                                <!-- filter by stutus -->
                                <div class="col-md-12" style="justify-content: center !important;">
                                    <div v-for="(st, index) in logistFilter" :key="index" class="badge custom_filter hand" :class="$t('tender.statuses.' + st.id + '.class')"  @click="filtrClick(st)" style="margin-left: 1%; margin-bottom: 1%;">
                                        <i :class="[st.checked ? 'icon-checkbox-checked' : 'icon-checkbox-unchecked']"></i>
                                        <span style="bagraund-color:#000">{{ $t('tender.statuses.' + st.id + '.title') }}</span>
                                    </div>
                                    <!-- filter by delivery -->
                                    <div v-for="(stat, sindex) in tender.deliveryStatus" :key="sindex+10" class="badge custom_filter hand" :class="$t('tender.deliveryStatus.' + stat.id + '.class')"  @click="filterBydeliveryClick(stat)" style="margin-left: 1%; margin-bottom: 1%;">
                                        <i :class="[stat.checked ? 'icon-checkbox-checked' : 'icon-checkbox-unchecked']"></i>
                                        <span style="bagraund-color:#000">{{ $t('tender.deliveryStatus.' + stat.id + '.title') }}</span>
                                    </div>
                                </div>
                            </div>


                        <!---------------- and filter block -->
                         <!-- ______________________________________main-tables    -->
                        <div class="main-tables mobileTbl table-responsive" >
                                <table class="table table-hover mb-0 loading" cellspacing="0" >
                                    <thead>
                                        <tr>     
                                            <th style="vertical-align: middle; width:110px">{{ $t('tender.table.number') }}</th>                                                           
                                            <th style="vertical-align: middle;">{{ $t('tender.table.openDay') }}<a @click="sortData('openDate')"><i class="icon-sort"></i></a></th> 
                                            <th style="vertical-align: middle;">{{ $t('tender.table.closeDay') }}<a @click="sortData('closeDate')"><i class="icon-sort"></i></a></th> 
                                            <th style="vertical-align: middle;">{{ $t('tender.table.status') }}</th>
                                            <!-- <th style="vertical-align: middle;">{{ $t('tender.table.downloadAdress') }}</th>                                            -->
                                            <th style="vertical-align: middle;">{{ $t('tender.table.deliveryAdress') }}</th>                                         
                                            <th style="vertical-align: middle;">{{ $t('tender.label.trType') }}</th>                                         
                                            <th style="vertical-align: middle;">{{ $t('tender.label.trDirection') }}</th>                                         
                                            <th style="vertical-align: middle;">{{ $t('tender.table.price') }}<a @click="sortData('cost')"><i class="icon-sort"></i></a></th>                           
                                            <th style="vertical-align: middle;">{{ $t('tender.table.countOfRate') }}<a @click="sortData('count')"><i class="icon-sort"></i></a></th>                           
                                            <th style="vertical-align: middle;">{{ $t('tender.table.responsible') }}</th>
                                            <th style="vertical-align: middle;">{{ $t('tender.table.coments') }}</th>     
                                            <th style="vertical-align: middle;"></th>                           
                                        </tr>
                                    </thead>                                                       
                                    <tbody >                              
                                        <tr class="marginTR" v-for="(item,index) in paginatedData" :key="index" @click="setActive"  :id="item.guidDoc"> 
                                            <td :data-title="$t('tender.table.number')">
                                                 {{item.number}}<br>
                                                 <span v-if="item.listOrder" class="order-list ">                                                       
                                                    {{item.listOrder}}                                                 
                                                </span>  

                                            </td>
                                            <td :data-title="$t('tender.table.openDay')"> <span>{{item.openDate}}</span></td>                                            
                                            <td :data-title="$t('tender.table.closeDay')"> <span :class="getCloseDateClass(item.closeDate)">{{item.closeDate}}</span></td>                                            
                                            <td :data-title="$t('tender.table.status')">
                                                 <span class="badge" :class="$t('tender.statuses.' + item.status + '.class')">{{ $t('tender.statuses.' + item.status + '.title') }}</span> 
                                            </td>                                            
                                            <!-- <td  :data-title="$t('tender.table.downloadAdress')">{{item.loadingAdress}}</td> -->
                                            <td  :data-title="$t('tender.table.deliveryAdress')">{{item.deliveryAdress}}</td>                                           
                                            <td  :data-title="$t('tender.label.trDirection')"><span >{{item.typeTransport}}</span></td>                                           
                                            <!-- <td  :data-title="$t('tender.label.trType')"><span class="tag" :class="getTrTypeClass(item.typeOpetation)">{{item.typeOpetation}}</span></td>                                   -->
                                            <td  :data-title="$t('tender.label.trType')"><span class="badge" :class="$t('tender.deliveryStatus.' + item.deliveryType + '.class')">{{ $t('tender.deliveryStatus.' + item.deliveryType + '.title') }}</span></td>                                  
                                            <td  :data-title="$t('tender.table.price')"><span  class="text-center  ">{{item.cost}}&nbsp;{{item.сurrency}}</span></td>
                                            <td  :data-title="$t('tender.table.additionally')">{{item.count}}</td>  
                                            <td  :data-title="$t('tender.table.responsible')">{{item.responsible}}</td> 
                                            <td  :data-title="$t('tender.table.coments')">{{item.comment}}</td> 
                                            <td> <a href="" ></a><font-awesome-icon icon="info" class="cursor warning"   />
                                             <!-- @click="goToRef(item.guidDoc)" -->
                                                 <!-- <a data-toggle="tooltip" :title="$t('tender.label.editTender')" href="" ></a><font-awesome-icon icon="edit" class="cursor warning"  @click="editTenderModal(item.id)"/> -->
                                                
                                            </td> 
                                        </tr>   
                                    </tbody>
                                </table>
                        </div>
                        <!-- ____________________and main tables -->
                    </div>


                    <div v-if="pageCount > 1" class="" style="text-align: center;">                           
                            <ul class="pagination">
                                <li class="page-item" v-if="pageNumber > 0">
                                    <a class="page-link" @click="pageNumber--" ><i class="icon-arrow-left2"></i></a>
                                </li>
                                
                                <li class="page-item" v-bind:class="{active : (pageNumber == (page - 1))}" v-for="(page, index) in pages" :key="index" >
                                    <a v-if="page != '...'" class="page-link" @click="pageNumber = (page - 1)">{{page}}</a>
                                    <a v-else class="page-link" :id="index">{{page}}</a>
                                </li>
                                
                                <li class="page-item" v-if="pageNumber < pageCount - 1">
                                    <a class="page-link"  @click="pageNumber++"><i class="icon-arrow-right2"></i></a>
                                </li>
                            </ul>
                        </div>

                 </div>
                <!--------------------------- Client view    ----------------------------    -->
                <div class="card" v-if="userRole == 'client'">
                    <div class="card-header">
                        <h3 class="card-title"><i class="icon-price-tags"></i> {{$t('titles.transport_tender')}}</h3>
                        <div class="heading-elements"> 
                            <button  data-toggle="tooltip" data-html="true" :title="$t('tender.button.update')" type="button" class="btn btn-sm btn-icon btn-outline-warning ex-button" @click="getAllTender()"><font-awesome-icon icon="sync" class="cursor warning"  /><span class="btn-desc">{{$t('tender.button.update')}}</span></button>                          
                            <!-- <button v-if="this.$store.getUserRoleAdmin" type="button" class="btn btn-warning"  data-toggle="modal" data-target="#modaNewTender" @click="newTenderModal = true">
                                <i style="color: #FFFFFF" class="icon-plus2"></i>
                            </button> -->
                            <!-- <span @click="changeView('table')" class="view-svicher"><i style="color: #000" class="icon icon-table"></i></span>
                            <span @click="changeView('card')" class="view-svicher"><i style="color: #000" class="icon icon-file-text"></i></span> -->
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-6 col-sm-12">
                                <!-- <modalEq :title="modalTitle" :methodId="chVarEq" :final_func="closeEqChoose" ></modalEq> --> 
                            </div>
                        </div>
                        <div class="container-fluid">
                            <div class="row" style="padding-left:20px">
                                <div class="col-md-12">
                                    <fieldset class="position-relative">
                                        <input type="text" class="form-control form-control input" placeholder="" v-model="filterStr" >
                                        <div class="form-control-position" style="top:13px; right:10px;">
                                            <i class="icon-search4 font-medium-4"></i>
                                        </div>
                                    </fieldset>
                                </div>
                            </div>
                        </div>                        

                        <div class="card-block pt-0" >                          
                            <div class="row" style="padding-left:7px">
                                <!-- filter by stutus -->
                                <div class="col-md-12" style="justify-content: center !important;">
                                    <div v-for="(st, index) in clientFilet" :key="index" class="badge hand custom_filter" :class="$t('tender.statuses.' + st.id + '.class')"  @click="filtrClick(st)" style="margin-left: 1%; margin-bottom: 1%;">
                                        <i :class="[st.checked ? 'icon-checkbox-checked' : 'icon-checkbox-unchecked']"></i>
                                        <span style="bagraund-color:#000">{{ $t('tender.statuses.' + st.id + '.title') }}</span>
                                    </div>
                                    <!-- filter by delivery -->
                                    <div v-for="(stat, sindex) in tender.deliveryStatus" :key="sindex+10" class="badge hand custom_filter" :class="$t('tender.deliveryStatus.' + stat.id + '.class')"  @click="filterBydeliveryClick(stat)" style="margin-left: 1%; margin-bottom: 1%;">
                                        <i :class="[stat.checked ? 'icon-checkbox-checked' : 'icon-checkbox-unchecked']"></i>
                                        <span style="bagraund-color:#000">{{ $t('tender.deliveryStatus.' + stat.id + '.title') }}</span>
                                    </div>
                                </div>
                            </div>

                        <!-- ______________________________________main-tables    -->
                        <div class="main-tables mobileTbl table-responsive outer" v-if="viewType">
                                <table class="table table-hover mb-0 loading" cellspacing="0" >
                                    <thead>
                                        <tr> 
                                            <th style="vertical-align: middle;"></th>    
                                            <th style="vertical-align: middle;">{{ $t('tender.table.numberStatus') }}</th>                                                           
                                            <th style="vertical-align: middle;">{{ $t('tender.table.closeDay') }}<a @click="sortData('closeDate')"><i class="icon-sort"></i></a></th>                                                           
                                            <th style="vertical-align: middle;">{{ $t('tender.table.downloadAdress') }}</th>
                                            <th style="vertical-align: middle;">{{ $t('tender.table.downloadDate') }}<a @click="sortData('loadingDate')"><i class="icon-sort"></i></a></th>                                                                                                         
                                            <th style="vertical-align: middle;">{{ $t('tender.table.productWeight') }}</th>
                                            <th style="vertical-align: middle;">{{ $t('tender.table.typeOfCarAndload') }}</th>
                                            <th style="vertical-align: middle;">{{ $t('tender.table.deliveryAdressAndDate') }}</th>
                                            <!-- <th style="vertical-align: middle;">{{ $t('tender.table.deliveryDate') }}</th>  -->
                                             
                                            <th style="vertical-align: middle;">{{$t('tender.table.userRate')}}</th> 
                                            <th style="vertical-align: middle;">{{$t('tender.table.bestUserRate')}}<a @click="sortData('minRate')"><i class="icon-sort"></i></a></th> 
                                            <th style="vertical-align: middle;">{{$t('tender.table.price')}}<a @click="sortData('cost')"><i class="icon-sort"></i></a></th>
                                            <th style="vertical-align: middle;">{{$t('tender.table.coments')}}</th>
                                            <th style="vertical-align: middle;"></th>                        
                                        </tr>
                                    </thead>                                                       
                                    <tbody>                              
                                        <tr class="marginTR" v-for="(item,index) in paginatedData" :key="index">
                                            <td ><span v-if="item.userRate <= item.minRate"><font-awesome-icon icon="long-arrow-alt-up" class="cursor success"/></span> <span v-else><font-awesome-icon icon="long-arrow-alt-down" class="cursor danger"/></span></td> 
                                            <td :data-title="$t('tender.table.numberStatus')">  
                                                <span class="badge" :class="$t('tender.statuses.' + item.status + '.class')">{{$t('tender.statuses.' + item.status + '.title')}}</span> <br>
                                                {{item.number}}<br>
                                                
                                               
                                            </td>

                                            <td :data-title="$t('tender.table.closeDay')"> {{item.closeDate}}</td>                                            
                                            <td :data-title="$t('tender.table.downloadAdress')"> {{item.arrayLoading[0].loadingAdress}}</td>                                            
                                            <td  :data-title="$t('tender.table.date')">{{item.arrayLoading[0].loadingDate}}</td>
                                            <td  :data-title="$t('tender.table.productWeight')">{{item.arrayLoading[0].weight}}</td>
                                            <td  :data-title="$t('tender.table.typeOfCarAndload')">{{item.arrayLoading[0].typeOfCar}}<br>{{item.arrayLoading[0].loadingType}}</td>
                                            <td  :data-title="$t('tender.table.deliveryAdressAndDate')"> <span class="badge" :class="$t('tender.deliveryStatus.' + item.deliveryType + '.class')">{{ $t('tender.deliveryStatus.' + item.deliveryType + '.title') }}</span><br><span v-for="(adress, k) in item.arrayDelivery" :key="k"><b v-if="item.arrayDelivery.length > 1">{{ $t('tender.label.deliveryP') +" "+(k+1) + ":" }}</b>{{adress.deliveryAdress}} <span class="deliv-dat">{{adress.deliveryDate}}</span> <br></span></td>
                                            <!-- <td  :data-title="$t('tender.table.deliveryDate')">
                                                <span class="deliv-date" v-for="(adress, k) in item.arrayDelivery" :key="k">{{adress.deliveryDate}}<br></span><br>
                                                
                                            </td> -->
                                            
                                            <td  :data-title="$t('tender.table.userRate')"><span v-if="item.userRate" :class="item.userRate <= item.minRate ? 'best_rate' :'not_best_rate' " class="text-center badge prise ">{{item.userRate}}&nbsp;{{item.currency}}</span>

                                            </td>
                                            <td  :data-title="$t('tender.table.bestUserRate')"><span v-if="item.minRate" class="text-center badge prise ">{{item.minRate}}&nbsp;{{item.currency}}</span></td>
                                            <td  :data-title="$t('tender.table.price')"><span v-if="item.cost" class="text-center badge prise ">{{item.cost}}&nbsp;{{item.currency}}</span></td>
                                            <td  :data-title="$t('tender.table.coments')">{{item.comment}}</td>
                                            <td v-if="$store.getters.getUserRoleClient"  >
                                                <!-- <button  class="btn btn-success btn-block mb-2" type="button" data-toggle="modal" data-target="#modalEq" @click="showmodal(item.id)">
                                                    {{$t('tender.button.confirm')}}
                                                </button> -->
                                                <div class="d-flex flex-column" v-if="item.status !=1">
                                                   
                                                    <button  v-if="item.status != 10 && item.status != 6 && item.status != 3 && item.status != 7 " data-toggle="tooltip" data-html="true" :title="item.userRate ? $t('label.canсel-part'): $t('label.not-intrest')"  id="tooltip-target-1" type="button" class="btn btn-sm btn-icon btn-outline-danger ex-button" @click="canselTenderByUserModal(item.id)"><font-awesome-icon icon="ban" class="cursor danger"  /><span class="btn-desc">{{item.userRate ? $t('label.canсel-part'): $t('label.not-intrest')}}</span></button>                                                   
                                                    <button  v-if="item.status != 10 && item.status != 6 && item.status != 2 && item.status != 3" data-toggle="tooltip" data-html="true" :title="$t('tender.label.offerABid')" type="button" class="btn btn-sm btn-icon btn-outline-warning ex-button" @click="addUserCommentModal(item.id)"><font-awesome-icon icon="hand-holding-usd" class="cursor warning"  /><span class="btn-desc">{{$t('tender.label.offerABid')}}</span></button>
                                                    <button  v-if="item.status != 10 && item.status != 6 && item.status != 7 && item.status != 2 && item.status != 3" type="button" class="btn btn-sm btn-icon btn-outline-success ex-button" data-toggle="modal" data-target="#modalEq" @click="showmodal(item.id)"><font-awesome-icon icon="money-check-alt" class="cursor success" data-toggle="tooltip" data-html="true" :title="$t('tender.label.takePart')"  /><span class="btn-desc">{{$t('tender.label.takePart')}}</span></button> 
                                                    <button  v-if="item.status != 10 && item.status == 2" data-toggle="tooltip" :title="$t('label.confirm')" type="button"  class="btn btn-sm btn-outline-success ex-button" @click="selectTender(item.id), confirmParticipation()"><i class="icon-checkmark"></i><span class="btn-desc">{{$t('label.confirm')}}</span></button>
                                                </div>
                                                <!-- <div class="form-group">
                                                    <div class="btn-group ">
                                                        <button  data-toggle="tooltip" data-html="true" :title="$t('label.canсel-part')" v-if="item.status != 6" id="tooltip-target-1" type="button" class="btn btn-sm btn-icon btn-outline-danger"><font-awesome-icon icon="ban" class="cursor danger"  @click="canselTenderByUserModal(item.id)"/></button>                                                   
                                                        <button  data-toggle="tooltip" data-html="true" :title="$t('tender.label.addComment')" type="button" class="btn btn-sm btn-icon btn-outline-warning"><font-awesome-icon icon="comment" class="cursor warning"  @click="addUserCommentModal(item.id)"/></button>
                                                        <button  v-if=" item.status != 6" type="button" class="btn btn-sm btn-icon btn-outline-success" data-toggle="modal" data-target="#modalEq" @click="showmodal(item.id)"><font-awesome-icon icon="money-check-alt" class="cursor success" data-toggle="tooltip" data-html="true" :title="$t('tender.label.takePart')"  /></button> 
                                                    </div>
                                                </div> -->

                                            </td>
                                        </tr>   
                                    </tbody>
                                </table>

                        </div>
                        <!-- ____________________and main tables -->
                        
                        <!-- ----------------------main list-----------------------     -->
                        <div class="main-list" v-if="!viewType">
                            <ul>
                                <li  v-for="(item,index) in paginatedData" :key="index">
                                    <div class="row item-row"  >
                                        <div class="col-md-4 col-sm-5">
                                            <span><b>{{$t('tender.table.id')}}:</b>  {{item.number}}</span><br/>
                                            <span><b>{{$t('tender.table.status')}}:</b> <span class="badge" :class="$t('tender.statuses.' + item.status + '.class')">{{ $t('tender.statuses.' + item.status + '.title') }}</span>                               
                                            <span v-if="item.status == 1 || item.status == 5"><b>{{$t('tender.table.duration')}}:</b>  {{item.closeDate}} </span> </span><br/>
                                            <span><b>{{$t('tender.table.coments')}}:</b>  {{item.comment}}</span>    
                                        </div>
                                        <div class="col-md-8 col-sm-7">
                                            <div class="d-flex flex-row-reverse prise-block"> 
                                                     <div class="justify-content-start mr-1">
                                                        <span v-if="item.cost"><b>{{$t('tender.table.price')}}:</b></span> <span v-if="item.cost" class="text-center badge prise ">{{item.cost}}&nbsp;{{item.currency}}</span> <br/>                                            
                                                    </div>
                                                    
                                                    <div class="justify-content-start mr-1">
                                                        <span v-if="item.minRate"><b>{{$t('tender.table.bestUserRate')}}:</b></span> <span v-if="item.minRate"  class="text-center badge prise ">{{item.minRate}}&nbsp;{{item.currency}}</span> <br/>                                            
                                                    </div>
                                                    <div class="justify-content-start mr-1" v-if="$store.getters.getUserRoleClient && item.userRate">
                                                        <span ><b>{{$t('tender.table.userRate')}}:</b></span> <span  class="text-center badge prise">{{item.userRate}}&nbsp;{{item.currency}}</span> <br/>  
                                                    </div>

                                                <div>
                                                    
                                                    <div >
                                                        <!-- <button v-if="$store.getters.getUserRoleClient" class="btn btn-success btn-block mb-2 mt-2" type="button" data-toggle="modal" data-target="#modalEq" @click="showmodal(item.id)">
                                                            {{$t('tender.button.confirm')}}
                                                        </button> -->
                                                        
                                                        <!-- && item.status ==1 && !item.userRate -->
                                                    </div>
                                                </div>
                                                <!-- --------------- -->
                                                <div class="mr-1 align-self-end">
                                                    <!-- <div class="justify-content-start mb-1">
                                                        <span v-if="item.minRate"><b>{{$t('tender.table.bestUserRate')}}:</b></span> <span  class="text-center badge prise ">{{item.minRate}}&nbsp;{{item.Currency}}</span> <br/>                                            
                                                    </div> -->
                                                    <!-- <div class="" >
                                                        <button v-if="$store.getters.getUserRoleClient && item.status ==5 && item.userRate " class="btn btn-danger btn-block mb-2 mt-2" type="button" data-toggle="modal" data-target="#modalEq" @click="canselTenderByUserModal(item.id)">
                                                            {{$t('tender.button.canсel')}}
                                                        </button>
                                                       
                                                    </div> -->
                                                </div>
                                            </div>                                             
                                        </div>
                                        <div class="row">
                                            <div class="col-md-12 loading">
                                                <div class="mobileTbl table-responsive ">
                                                    <span class="table-head badge">{{ $t('tender.label.loadPoint') }}</span>
                                                    <table class="table table-hover mb-0 loading" cellspacing="0" >
                                                        <thead>
                                                            <tr>                                                                
                                                                <th style="vertical-align: middle;">{{ $t('tender.table.adress') }}</th>
                                                                <th style="vertical-align: middle;">{{ $t('tender.table.date') }}</th> 
                                                                <th v-if="item.arrayLoading[0].customsCrossing" style="vertical-align: middle;">{{ $t('tender.table.customsCrossing') }}</th>                                                                                                                         
                                                                <th style="vertical-align: middle;">{{ $t('tender.table.productWeight') }}</th>
                                                                <th style="vertical-align: middle;">{{ $t('tender.table.typeOfCar') }}</th>
                                                                <th style="vertical-align: middle;">{{ $t('tender.table.downloadType') }}</th>                          
                                                            </tr>
                                                        </thead>                                                       
                                                        <tbody>                              
                                                            <tr class="marginTR" v-for="(sitem,sindex) in item.arrayLoading" :key="sindex"> 
                                                                <td :data-title="$t('tender.table.download')"> {{sitem.loadingAdress}}</td>
                                                                <td :data-title="$t('tender.table.date')"> {{sitem.loadingDate}}</td>
                                                                <td v-if="sitem.customsCrossing"  :data-title="$t('tender.table.customsCrossing')">{{sitem.customsCrossing}}</td>
                                                                <td  :data-title="$t('tender.table.productWeight')">{{sitem.weight}}</td>
                                                                <td  :data-title="$t('tender.table.typeOfCar')">{{sitem.typeOfCar}}</td>
                                                                <td  :data-title="$t('tender.table.downloadType')">{{sitem.loadingType}}</td>
                                                            </tr>   
                                                        </tbody>
                                                    </table>
                                                </div>

                                            </div>


                                            <div class="col-md-12 delivery">
                                                <div class="mobileTbl table-responsive">
                                                    <span class="table-head badge ">{{ $t('tender.label.deliveryPoint') }}</span>
                                                    <table class="table table-hover mb-0 delivery" cellspacing="0" >
                                                        <thead>
                                                            <tr>                                                                                                                           
                                                                <th style="vertical-align: middle;"></th>
                                                                <th style="vertical-align: middle;">{{ $t('tender.table.adress') }}</th>
                                                                <th style="vertical-align: middle;">{{ $t('tender.table.date') }}</th>                                                              
                                                            </tr>
                                                        </thead>                                                       
                                                        <tbody>                              
                                                            <tr class="marginTR" v-for="(delivery,dindex) in item.arrayDelivery" :key="dindex">
                                                                <td>{{ $t('tender.label.deliveryP') +" "+(dindex+1) }}</td>                                                                        
                                                                <td :data-title="$t('tender.table.delivery')">
                                                                    <span class="badge" :class="$t('tender.deliveryStatus.' + item.deliveryType + '.class')">{{ $t('tender.deliveryStatus.' + item.deliveryType + '.title') }}</span> <br>
                                                                    {{delivery.deliveryAdress}}                                                                           
                                                                </td> 
                                                                    <td :data-title="$t('tender.table.date')">
                                                                    {{delivery.deliveryDate}}                                                                          
                                                                </td>                                      
                                                            </tr> 
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="d-flex flex-row-reverse item-button">
                                            <div class="form-group">
                                                <div class="btn-group ">
                                                   <button  v-if="item.status !=6 && item.status != 2 " data-toggle="tooltip" data-html="true" :title="item.userRate ? $t('label.canсel-part'): $t('label.not-intrest')"  id="tooltip-target-1" type="button" class="btn btn-icon btn-outline-danger"><font-awesome-icon icon="ban" class="cursor danger"  @click="canselTenderByUserModal(item.id)"/></button>                                                   
                                                    <button v-if="item.status != 2" data-toggle="tooltip" data-html="true" :title="$t('tender.label.addComment')" type="button" class="btn btn-icon btn-outline-warning"><font-awesome-icon icon="comment" class="cursor warning"  @click="addUserCommentModal(item.id)"/></button>
                                                    <button  v-if="item.status != 6 && item.status != 7 && item.status != 2" type="button" class="btn btn-icon btn-outline-success" data-toggle="modal" data-target="#modalEq" @click="showmodal(item.id)"><font-awesome-icon icon="money-check-alt" class="cursor success" data-toggle="tooltip" data-html="true" :title="$t('tender.label.takePart')"  /></button>
                                                    <button v-if="item.status == 2" type="button"  class="btn btn-icon btn-outline-danger btn-glow mr-1" @click="$modal.show('cancel-user-part')"><font-awesome-icon icon="ban" class="cursor danger" /> {{$t('label.refuse')}}</button>
                                                    <button v-if="item.status == 2" type="button"  class="btn btn-icon btn-outline-success" @click="selectTender(item.id), confirmParticipation()"><font-awesome-icon icon="check" class="cursor success" /> {{$t('label.confirm')}}</button> 
                                                </div>
                                            </div>
                                    </div>

                                </li>
                            </ul>
                            
                        </div>
                        <!-- ----------------------and main list-----------------------     -->
                      
                        <div v-if="pageCount > 1" class="" style="text-align: center;">                           
                            <ul class="pagination">
                                <li class="page-item" v-if="pageNumber > 0">
                                    <a class="page-link" @click="pageNumber--" ><i class="icon-arrow-left2"></i></a>
                                </li>
                                
                                <li class="page-item" v-bind:class="{active : (pageNumber == (page - 1))}" v-for="(page, index) in pages" :key="index" >
                                    <a v-if="page != '...'" class="page-link" @click="pageNumber = (page - 1)">{{page}}</a>
                                    <a v-else class="page-link" :id="index">{{page}}</a>
                                </li>
                                
                                <li class="page-item" v-if="pageNumber < pageCount - 1">
                                    <a class="page-link"  @click="pageNumber++"><i class="icon-arrow-right2"></i></a>
                                </li>
                            </ul>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>    
  </div> 
</template>
<script>
//import json from "../structure.json";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import dayjs from 'dayjs'
var customParseFormat = require('dayjs/plugin/customParseFormat')
dayjs.extend(customParseFormat)
var isBetween = require('dayjs/plugin/isBetween')
dayjs.extend(isBetween)
  export default {
    name: "transport_tender",
    components: {   
             DatePicker
        },
    data(){
      return{
          momentFormat: {
            //[optional] Date to String
            stringify: (date) => {
                return date ? this.$moment(date).format('DD.MM.YYYY HH:mm:ss') : ''
            },
            //[optional]  String to Date
            parse: (value) => {
                return value ? this.$moment(value, 'DD.MM.YYYY HH:mm:ss').toDate() : null
            },
            //[optional] getWeekNumber
            getWeek: (date) => {
                return // a number
            }
        },
        winnerSubmited:false,
        viewTable:false,
        canselTenderId:null,
        reasonForCancellation:"",
        commentForWinner:"",
        showModalCansel:false,
        listOfTender:{},
        userComment:"",
        selecteadTender: {},
        newTenderModal:false,
        chVarEq: null,
        showVars: false,
        user_rate:null,
        user_rate_currency:null, 
        winnRate:null,       
        modalTitle:"Підтвердити участь",
        modalNimHeaght:"270px",
        filterStr: "",
        pageNumber: 0,
        direction: 'asc',
        classSort: 'icon-sort-amount-asc',
        boolDir: true,
        sortKey: '',
        size:8,
        paggSize:5,
        descTablesData:null,
        timerId:null,
        activeRowClass:null,
        svgNoTax:require('../assets/icons/tax-free.svg'),
        svgBestRate:require('../assets/icons/best-rate.svg'),
        tender: {
          typeOfTansportationVal: null,
          statuses:[
            {name: 'statuses.all', value: '', id: 0, checked: true, clientFilter:true, logistFilet:true},
             {name: "statuses.active", value: "active", id: 4, checked: false, clientFilter:false, logistFilet:true},
             {name: "statuses.inconfirm", value: "inconfirm", id: 2, checked: false, clientFilter:false, logistFilet:true},
                                    
            {name: "statuses.closed", value: "closed", id: 3, checked: false, clientFilter:false, logistFilet:true},           
            {name: "statuses.vinnerset", value: "vinnerset", id: 5, checked: false, clientFilter:false, logistFilet:false},
            {name: "statuses.new", value: "new", id: 9, checked: false, clientFilter:true, logistFilet:false},
            {name: "statuses.takepart", value: "takepart", id: 8, checked: false, clientFilter:true, logistFilet:false},
            {name: 'statuses.confirmed',value: 'confirmed', id: 1, checked: false, clientFilter:true, logistFilet:true},
            {name: "statuses.ratecanseled", value: "ratecanseled", id: 6, checked: false, clientFilter:true, logistFilet:false},
            {name: "statuses.notintrast", value: "notintrast", id: 7, checked: false, clientFilter:true, logistFilet:false},
            {name: "statuses.lost", value: "lost", id: 10, checked: false, clientFilter:true, logistFilet:false},
            
            
          ],
          deliveryStatus:[
            //   {name:'delivery.all', value:'', id:0, checked:true},
              {name:'delivery.in', value:'', id:1, checked:false},
              {name:'delivery.out', value:'', id:2, checked:false},
          ],
            choosen:[
                {name: 'statuses.all', value: '', id: 0, checked: true},
            ]   
        },
        newTender:{
            type:null,
            price:null,
            сurrency:null,
            children:[],
        },
       newTenderChildren:{
           downloadAdress:null,
           downloadDate:null,
           deliveryAdress:null,
           deliveryDate:null,
           productWeight:null,
           typeOfCar:null,
           downloadType:null
       } 
      }
    },
    methods: {
        getCloseDateClass(item){   
            // console.log(item);       
            let itemday = dayjs(item, 'DD.MM.YYYY HH:mm:ss', true)
            let plus2 = dayjs().add(1, 'day')
            if(itemday.isBefore(plus2)) {
                return "danger"
            }
            else return "success"         

        },
        getCostClass(array, index, cost){                    
            if (index+1== array.length){ return 'best'}
            else return 'not-best'
        }, 
        isBestCost(cost){           
           
            // if (parseInt(cost,10) == parseInt(this.descTablesData.mainRate.replace(/\s/g, ''),10)){
            if (parseInt(cost,10) == parseInt(this.descTablesData.mainRate,10)){
                console.log(true)
                return true
            }
        },       
        getTrTypeClass(val){            
         return val == "Внешняя" ? "tag-success" : "tag-info"           

        },
        
        canselTenderModal(){      
            this.$modals.show("cansel-tender");
        },
        canselTenderByUserModal(id){ 
            this.canselTenderId = id;           
            this.$modal.show('cancel-user-part')
            this.selecteadTender = _.find(this.listOfTender, o => o.id == id);  
            this.showModalCansel = true;
        },
        addUserCommentModal(id){                  
            this.$modal.show('user-comment')
            this.selecteadTender = _.find(this.listOfTender, o => o.id === id);  
            
        },
        editTenderModal(id){             
            this.$modal.show('edit-tender')
            this.selecteadTender = _.find(this.listOfTender, o => o.id == id);  
            
        },
        editTender(){
            loncole.log("send request")
        },
        // closeModal(){

        // },
        calculateBestRate(){
            // if(this.selecteadTender.minRate && this.selecteadTender.minRate ==0){
            //     {this.user_rate = this.selecteadTender.minRate}
            // }
            if(this.selecteadTender.minRate && this.selecteadTender.minRate > 0)
                {this.user_rate = this.selecteadTender.minRate - this.selecteadTender.step}
            else {
                this.user_rate = this.selecteadTender.cost
            }
             
        },
       
        getTenderDesc(id){
            this.winnerSubmited = false;
            let dataRequest = {
                guidClient: this.$store.state.guidClient,
                guidDoc:id,               
                };
            this.makeQuery("/portal/getInfoTender", {dataRequest : dataRequest, token: this.$store.state.userToken })
                .then(res => {
                    if(res != null){ 
                        if(res.data.data ) {this.descTablesData = res.data.data }                                                    
                     
                    }
                });

        },
        submitRate(){
          
            let dataRequest = {
                guidClient: this.$store.state.guidClient,
                guidTender:this.selecteadTender.guidDoc,
                rate:this.user_rate,
                currency:this.selecteadTender.currency,
                dpv: localStorage.getItem('pdv')
                };
                // dataRequest.guidClient = this.$store.state.guidClient;
                this.makeQuery("/portal/addratetender", {dataRequest : dataRequest, token: this.$store.state.userToken })
                .then(res => {
                    if(res != null){
                         this.$store.state.modalBody = false  
                         this.getAllTender() 
                         if(res.data.result) {
                            this.showNotification('custom-success','Успіх', res.data.data);
                         }
                         else {
                            this.showNotification('custom-error','Успіх', res.data.data);
                         }
                         
                      
                    }
                    else {
                        this.$store.state.modalBody = false
                        this.showNotification('custom-error','Помилка',"Ваша пропозиція не подана. Спробуйте ще раз");
                    }
                });
        },
        setWinTender(){
            let dataRequest = {
                guidClient: this.winnRate.guidClient,
                guidDoc:this.descTablesData.guidDoc,
                comment:this.commentForWinner                
                }; 
                this.makeQuery("/portal/setWinTender", {dataRequest : dataRequest, token: this.$store.state.userToken })
                .then(res => {
                    if(res != null && res.data.result){ 
                        this.showNotification('custom-success','Успіх',"Дані оновлено");  
                        this.$modal.hide('select-winner'); 
                        this.winnerSubmited = true;
                        // this.getTenderDesc(this.descTablesData.guidDoc) 
                        this.getAllTender();                                                            
                       console.log(res);
                    }
                });

        },
        canselTender(guidDoc){
            let dataRequest = {                
                guidDoc:guidDoc                
                };               
                this.makeQuery("/portal/cancelTender", {dataRequest : dataRequest, token: this.$store.state.userToken })
                .then(res => {
                    if(res != null && res.data.result){ 
                        this.showNotification('custom-success','Успіх',"Тендер видалений");  
                        this.closeModal('cansel-tender') ; 
                        this.descTablesData = null 
                        this.getAllTender(); 
                                                     
                       console.log(res);
                    }
                });

        },
        closeTender(){
            let dataRequest = {                
                guidDoc:this.descTablesData.guidDoc                
                };               
                this.makeQuery("/service/closeTender", {dataRequest : dataRequest, token: this.$store.state.userToken })
                .then(res => {
                    if(res != null && res.data.result){ 
                        this.showNotification('custom-success','Успіх',"Тендер закритий");  
                        this.$modal.hide('close-tender')
                        this.descTablesData = !this.descTablesData;
                        // this.descTablesData = null 
                        this.getAllTender(); 
                                                     
                       console.log(res);
                    }
                });

        },
        updateTende(){
            let dataRequest = {                
                guidDoc:this.selecteadTender.guidDoc,
                closeDate:this.selecteadTender.closeDate,            
                cost:this.selecteadTender.cost,            
                };               
                this.makeQuery("/portal/changeTender", {dataRequest : dataRequest, token: this.$store.state.userToken })
                .then(res => {
                    if(res != null && res.data.result){ 
                        this.showNotification('custom-success','Успіх',"Тендер змінено");  
                        this.$modal.hide('edit-tender')
                        // this.descTablesData = null 
                        this.getAllTender();                                                      
                       console.log(res);
                    }
                });

        },
        canselUserPart(){
            let type = this.selecteadTender.userRate ? 2 : 1;
            let dataRequest = {                
                guidDoc:this.selecteadTender.guidDoc,
                clientGuid:this.$store.getters.getCurrentUser,
                comment:this.reasonForCancellation,
                type: type            
                };               
                this.makeQuery("/portal/cancelPlayTender", {dataRequest : dataRequest, token: this.$store.state.userToken })
                .then(res => {
                    if(res != null && res.data.result){ 
                        this.showNotification('custom-success','Успіх',"");  
                        this.$modal.hide('cancel-user-part'); 
                        this.reasonForCancellation = null 
                        this.getAllTender(); 
                                                     
                       console.log(res);
                    }
                }); 


            // this.reasonForCancellation = null;
            console.log("cancel User part")
        },
        selectTender(id){
            this.selecteadTender = _.find(this.listOfTender, o => o.id == id);
        },
        confirmParticipation(){           
            let dataRequest = {
                guidDoc:this.selecteadTender.guidDoc,
                guidClient: null
                };
            dataRequest.guidClient = this.$store.getters.getGuidClient;          
            this.makeQuery("/portal/setApproveTender", {dataRequest : dataRequest, token: this.$store.getters.getUserToken  })
            .then(res => {
                if(res.data.result){ 
                    this.showNotification('custom-success','Успіх', res.data.data);  
                    this.getAllTender(); 
                //    console.log(res.data.data);
                }
            });
        },
        addUserComment(){
             let dataRequest = {                
                guidDoc:this.selecteadTender.guidDoc,
                clientGuid:this.$store.state.client,
                comment:this.userComment,             
                };
            this.makeQuery("/portal/addMessagesTender", {dataRequest : dataRequest, token: this.$store.state.userToken })
            .then(res => {
                if(res != null && res.data.result){ 
                    this.showNotification('custom-success','Успіх',"");  
                    this.$modal.hide('user-comment'); 
                    this.userComment = "";                             
                    console.log(res);
                }
                else {
                    this.showNotification('custom-error','Помилка', res.data);
                }
            }); 
        },
        addNewTender(){
            console.log('addNewTender')
        },
        addLineTuTables(index){
            this.newTender.children.push(this.newTenderChildren);
            let rez = {}
            _.forEach(this.newTenderChildren, function(value, key) {
                 rez[key] = null;
            });
            this.newTenderChildren = rez;

        },
        getAllTender(){                            
                let dataRequest = {guidClient: null};               
                dataRequest.pdv = this.$store.getters.getUserPdv;
                dataRequest.guidClient = this.$store.state.guidClient;
                dataRequest.variant = 1;
                this.makeQuery("/portal/getlisttender", {dataRequest : dataRequest, token: this.$store.state.userToken }, false)
                .then(res => {
                    if(res.data.result){ 
                        this.listOfTender = _.orderBy(res.data.data , 'status', 'desc');                   
                    //    console.log(res.data.data);
                    }
                });           
        },
         getTenderInfo(id){                            
            let dataRequest = {
                guidTender: null,
                guidClient: null
                };
            dataRequest.guidClient = this.$store.getters.getGuidClient;         
            dataRequest.guidTender = id;          
            this.makeQuery("/portal/getInfoTenderClient", {dataRequest : dataRequest, token: this.$store.getters.getUserToken })
            .then(res => {
                if(res.data.result){ 
                    this.selecteadTender = res.data.data[0];
                    let el = _.findIndex(this.listOfTender, o => o.id == id);
                    this.listOfTender[el]= res.data.data[0];
                    this.calculateBestRate()                                  
                //    console.log(res.data.data);
                }
            });           
        },
         chackRate(id){                            
            let dataRequest = {
                guidTender: null,
                guidClient: null
                };
            dataRequest.guidClient = this.$store.getters.getGuidClient;         
            dataRequest.guidTender = id;          
            this.makeQuery("/portal/chackRate", {dataRequest : dataRequest, token: this.$store.getters.getUserToken })
            .then(res => {
                if(res.data.result){ 
                    this.selecteadTender.min_rate = res.data.min_rate;
                    this.calculateBestRate();
                   // let el = _.findIndex(this.listOfTender, o => o.id == id);
                    // this.listOfTender[el]= res.data.data[0];
                                                      
                //    console.log(res.data.min_rate);
                }
            });           
        },
        filterBydeliveryClick(item){
            let active = _.find(this.tender.deliveryStatus,function(o) { return o.id == item.id; })
            active.checked = !active.checked;            
        },       

        filtrClick(item){
                //  this.tender.filterchoosen = [],
                // this.tender.statuses[index].checkeded = !this.tender.statuses[index].checkeded;
                // index != 0 ? this.tender.statuses[0].checkeded = false : this.tender.statuses[0].checkeded = true;

                // this.tender.filterchoosen.push(item.id)
                let arr = this.tender;                
                arr.choosen = [];
                let notall = false;
                item.checked = !item.checked;
                let bool = item.checked;

                let itemAll =  arr.statuses[0];

                if(item == itemAll){
                    for (let i = 0; i <  arr.statuses.length; i++){
                        if( arr.statuses[i] != item){ arr.statuses[i].checked = false;}
                    }
                } else {
                    if(itemAll.checked == true){
                        item.checked = true;
                        for (let i = 0; i <  arr.statuses.length; i++) {
                            if( arr.statuses[i] != item){
                                 arr.statuses[i].checked = false;
                            }
                            
                        }
                    } else {
                        for (let i = 0; i <  arr.statuses.length; i++) {
                            if(( arr.statuses[i].checked == false) && ( arr.statuses[i] != itemAll)){
                                notall = true;
                            }
                            
                        }

                        console.log(notall)
                        if(notall == true){
                            itemAll.checked = false;
                        } else {
                            itemAll.checked = true;
 
                            for (let i = 0; i <  arr.statuses.length; i++) {
                                if( arr.statuses[i] != itemAll){
                                     arr.statuses[i].checked = false;
                                }
                            }
                        }
                    }
                }

                //нажаті
                for (let i = 0; i <  arr.statuses.length; i++) {
                    if( arr.statuses[i].checked == true){
                        arr.choosen.push( arr.statuses[i]);
                    }
                }
                if(arr.choosen.length < 1){
                    arr.statuses[0].checked = true;
                    arr.choosen.push(arr.statuses[0]);
                }

                
            },
        showmodal(id){
        console.log(id);
        this.chVarEq = 1; 
        this.$store.state.modalBody = true; 
        let tender = _.find(this.listOfTender, o => o.id == id);
        
         
        // this.showVars = false;
        // this.selecteadTender = _.find(this.listOfTender, o => o.id == id);  
        //this.getTenderInfo(tender.id)
        this.selecteadTender = tender; 
        this.chackRate(tender.id) 
             
      },
      showCustomModal(id){
          this.$modal.show(id)
      },
      closeEqChoose(){
                this.chVarEq = null;
            },
      sortData(key){
                if (this.sortKey == key){
                    this.boolDir = !this.boolDir;
                } else {
                    this.boolDir = false;
                }
                if (this.boolDir){
                    this.direction = 'asc';
                    this.classSort = 'icon-sort-amount-asc';
                } else {
                    this.direction = 'desc';
                    this.classSort = 'icon-sort-amount-desc';
                }

                this.sortKey = key;
            },
        changeView(data){
            // let cval = this.$store.getters.getViewType;
            // if (cval == "card"){this.$store.commit('setViewType', "table");  }
            this.$store.commit('setViewType', data);            
        },
         goToRef(item){
        console.log(`item = ${item}`)
        // this.descTablesData = item;        
        this.getTenderDesc(item)
        this.anchorTo("desc")
    //   $('#collapse41').collapse('hide')
    },
     showModalWinn: function (item,modal) {         
          this.$modal.show(modal);
          this.winnRate = item;
      },
      closeModal(name){
        // console.log(name)
        this.$modals.hide(name);
      },
       startevent(){
           let self = this;
           console.log("start job")
           this.timerId = setInterval(work, 60000)
           function work(){
               self.getAllTender();
           } 
        //    _.debounce(work, 600)();          
         },
         setActive(e){ 
            //  console.log(e);
             let activeItemId             
             if (e.target.localName == "td"){activeItemId = e.target.parentElement.id;}
             else {activeItemId = e.target.parentElement.parentNode.id}
             this.goToRef(activeItemId);        
            if(this.activeRowClass) {this.unsetActive(this.activeRowClass)}
            e.currentTarget.className += " active";  
            this.activeRowClass = true;          
         },
         unsetActive(target){
             let elements = document.querySelectorAll('.active');
             if (elements){
                for (let elem of elements) {
                    elem.classList.remove('active');
                }
            }            
         }
    },    
    computed:{
        uid(){
            return `${this.$_uid}`;  // e.g. input-1
        },
        minRate(){
            let minRate = parseFloat(this.selecteadTender.minRate) || 0;
           return minRate > 0 ? minRate : parseFloat(this.selecteadTender.cost)
        },
        optimalRate(item){
            return "ok"
        },
        userRole(){
            if(this.$store.getters.getUserRoleAdmin || this.$store.getters.getUserRoleLogist){
                return  "admin"    
            }
            else return "client"
           
        },
        viewType(){
            return this.$store.getters.getViewType == "table" ? true : false
        },
        logistFilter(){
            return _.filter(this.tender.statuses, 'logistFilet' )
        },
        clientFilet(){
            return _.filter(this.tender.statuses, 'clientFilter' )
        },
        filterLogist(){
            let filterStr = this.filterStr.toLowerCase();
            if (!_.isEmpty(this.listOfTender)){
            }
        },
      listFiltered: function(){
                let self = this;
                let find = this.filterStr.toLowerCase();
                let filterBystatus = this.tender.statuses;
                let found1 = true;
                let found2 = false;                
                this.pageNumber = 0;
                function filterByDelivery(item){
                    let checked = _.find(self.tender.deliveryStatus, function (o){return o.checked})
                    if(!checked) {return true}
                    else if(item.deliveryType == checked.id){return true}
                    else return false;
                }
               if (!_.isEmpty(this.listOfTender)){
                   return this.listOfTender.filter(item => {
                    found1 = false;
                    found2 = false;
                    if( (find == '') || ((item.id != null) && (item.id.toLowerCase().indexOf(find) > -1)) 
                    || ((item.number != null) && (item.number.toLowerCase().indexOf(find) > -1)) 
                    || ((item.typeTransport != null) && (item.typeTransport.toLowerCase().indexOf(find) > -1)) 
                    || ((item.typeOpetation != null) && (item.typeOpetation.toLowerCase().indexOf(find) > -1)) 
                    || ((item.responsible != null) && (item.responsible.toLowerCase().indexOf(find) > -1)) 
                    || (item.deliveryAdress && (item.deliveryAdress != null) && (item.deliveryAdress.toLowerCase().indexOf(find) > -1)) 
                    || (item.loadingAdress && (item.loadingAdress != null) && (item.loadingAdress.toLowerCase().indexOf(find) > -1)) ){
                        found1 = true;
                    }

                    for (let i = 0; i < this.tender.choosen.length; i++){
                        if( (this.tender.choosen[i].id == 0) || ((item.status != null) && (item.status == this.tender.choosen[i].id))){
                            found2 = true; 
                            break;
                        }
                    }

                    if(found1 && found2 && filterByDelivery(item)){
                        return item;
                    }
                })
                }
                else return {}
              
                
            },
            userRateError: function () {  
                let u_rate = 0;                
                let t_rate = 0;
                let step = parseFloat(this.selecteadTender.step) || 0;
                let minRate = parseFloat(this.selecteadTender.minRate) || 0;
                // if (minRate == 0){
                //     t_rate = parseFloat(this.selecteadTender.cost)
                // }
                // else {
                //     t_rate = minRate - step
                // }





                minRate > 0 ? t_rate = minRate - step : t_rate = parseFloat(this.selecteadTender.cost);
                
                // if (this.selecteadTender.Cost != undefined && this.selecteadTender.Cost != 0 ) {                                               
                //     t_rate = parseFloat(this.selecteadTender.Cost);                         
                //     }                
                // console.log(`t_rate = ${t_rate}`)
                if (t_rate == 0) {return false};
                if (this.user_rate && this.user_rate.length > 0){
                        u_rate = parseFloat(this.user_rate); 
                }
                // console.log(`this.user_rate = ${this.user_rate}`)  
                // console.log(`u_rate = ${u_rate}`)                
                if(this.user_rate > 0 && this.user_rate <= t_rate) {
                    return false;
                }
                else return true;       
            },
            pageCount(){
                let l = this.listFiltered.length, s = this.size;
                return Math.ceil(l/s);
            },
            pages: function(){
                let arr = [];
                for (let i = 0; i < this.pageCount; i++) { 
                    arr[i] = i + 1;
                }
                let divider = Math.trunc(this.paggSize/2);
                let start = this.pageNumber - divider;
                let end = this.pageNumber + divider + 1;
                if (start < 0) {
                    start = 0;
                }
                let final_arr = arr.slice(start,end);
                if ((start + 1) > arr[0]){
                    final_arr.unshift('...');
                }
                if(end < arr[arr.length - 1]){
                    final_arr.push('...');
                }
                return final_arr;
            },
            paginatedData(){
                if (this.sortedData.length > 0){
                    const start = this.pageNumber * this.size,
                        end = start + this.size;
                    return this.sortedData.slice(start, end);
                }
            },
            sortedData: function () {
                return _.orderBy(this.listFiltered, this.sortKey, this.direction);
            },
    },
    created() {
        
    },
    mounted(){
        this.$store.commit('setViewType', 'table');
        // this.columns['0']['label'] = this.$t('equipm.table.codeModel')
        this.getAllTender();
        this.startevent();
        $(function () { $('[data-toggle="tooltip"]').tooltip() })
    },
    beforeDestroy(){
        console.log('stop timer' + this.timerId );
        window.clearTimeout(this.timerId);
    }

  }
</script>

<style scoped>
#desc {
    background-color: rgb(250, 250, 250);
    margin: 3px 20px;
}
#tender .v-modal__heading {
    padding: 5px;
}
#tender{
font-family: Inter,sans-serif!important;
font-size: 0.8rem;
}
#tender fieldset {
  padding: 10px;
}
/* .table-responsive {
    padding-top: 7px;
} */
.mobileTbl th{
     /* border-top: 1px solid #999; */
     border-top:0px;
}


.main-list ul li {
 list-style: none;
 border: 3px solid #999;
 background-color: #fffbfb;
 padding: 10px 10px;
 margin: 5px 5px;
 margin-top: 10px;;
}
.main-list ul {
    padding-left: 10px;
}
.main-list ul:first-child {
    margin-top: 30px;
}
.loading {
    margin-top: 5px;
}

.delivery{
    margin-top: 15px;

}

.table-head {
    font-size: 0.8rem;
    border-radius: 0;
    padding: 10px 0px;
    font-weight: 600; 
    margin-left: 15px;
    color: black;
    border-bottom: 1px solid #999;
    /* padding-left: 5px; */
    /* display: block;
    border: 1px solid #999;
    padding: 10px 10px; */
    
}
.table th, .table td {
    padding: 0.5rem 0.5rem;
}
.prise {
    padding: 10px 10px;
     border: 1px solid #999;
     float: right;
     margin-left: 5px;
}
.table .prise {
     float: none;
}
.view-svicher i{
cursor: pointer;
width: 40px;
height: 40px;
}
.cursor {
  cursor: pointer;
  width: 20px;
  height: 20px;
}
.action-icon {
  cursor: pointer;
  margin: 5px 10px;
  width: 40px;
  height: 40px;
  }
  .acsept-desk {
      color: #999;
      font-size: 0.8rem;
  }
.btn-icon:hover {
    background: none !important;
    color: #000 !important;
}
.btn-desc {
    margin: 0 2px;
    line-height: 2.1;
}
.best_rate{
    border-color: #36b304;
    color: #36b304;
}
.not_best_rate {
    border-color: #DA4453;
    color: #DA4453;
}
.custom_filter {
    font-size: 90%;
}
.tooltip {
  display: block !important;
  z-index: 1000000;
  min-width: 200px !important;
}

.tooltip .tooltip-inner {
  background: black;
  color: white;
  border-radius: 16px;
  padding: 5px 10px 4px;
}
.vm--modal {
    min-height: 400px;
}
.not-best {
    text-decoration: line-through;
    font-size: 0.7 ;   
    color:rgb(197, 197, 197)
    
}
.best {
    font-weight: bold;
}

.bg-orange {
  background-color: #EF6C00 !important; 
  }
  .bg-brown {
  background-color: #795548!important;
  color: #fff;
  }
 
  .bg-purple {
    background-color: #9C27B0!important;  
    color: #fff;
  }
  .bg-lime {
      background-color: #CDDC39!important;
  }
  .bg-purple span, .bg-purple i {
      color: #fff;
  }
  .item-row {
      margin: 0px 0px;
  }
  .item-button {
      margin-top: 10px;
  }
  .ex-button {
      margin-bottom: 5px;
  }
.card-title{
    text-transform: none;
}
.deliv-date {
    margin-top: 10px;
    display: block;
}
.deliv-dat {
    margin-top: 5px;
    display: block;
    color: #999;
}
.editional-info {
border: 1px solid #f10b0b;
margin: 20px 20px;
padding: 10px 10px;
}
.outer{
    overflow-y: auto;
    height:500px;
    width: 102%;
    }

.outer table{
    width: 100%;
    /* table-layout: fixed;  */
    /* border : 1px solid black; */
    border-spacing: 1px;
}

.outer table th {
        text-align: left;
        top:0;
        position: sticky;
        background-color: white;  
}

.main-tables .active {
    background-color: rgba(140, 212, 24, 0.075);
}
.main-tables .marginTR {
    cursor: pointer;
}
.icon-sort {
    margin-left: 5px;
}
.svgIcon {
    filter: invert(38%) sepia(79%) saturate(2476%) hue-rotate(-41deg) brightness(118%) contrast(119%);
    width: 60px;
}
.order-list {
    display: block;
    margin-top: 5px;
    color: #999;
}
/* .tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: black;
} */



/* .tooltip[aria-hidden='true'] {
  visibility: hidden;
  opacity: 0;
  transition: opacity .15s, visibility .15s;
}

.tooltip[aria-hidden='false'] {
  visibility: visible;
  opacity: 1;
  transition: opacity .15s;
} */
@media only screen and (max-width: 800px) {
.table-hover {
    padding: 5px 5px;
}
.prise {
    padding: 5px 5px;   
    float: none;
    margin-left: 1px;
}
.card-body {
    padding: 0px;
}
.prise-block {
    flex-direction: row !important;
}
.mobileTbl td {
    border: none;
    border-bottom: 1px solid #eee;
    position: relative;
    padding-left: 50%;
    white-space: normal;
    text-align: left;
    min-height: 2rem;
}
}

</style> 


// WEBPACK FOOTER //
// src/pages/Transport_tender.vue